<template>
  <div class="bg-white filters--container">
    <div class="w-full flex justify-between border-b border-t border-zt-dark-200 p-4">
      <div class="filter--action border items-center justify-center cursor-pointer"
        :class="[showFilterOptions ? 'filter--action-open' : '']" @click="showFilterOptions = !showFilterOptions"
        data-vs-button="show-opts">
        <zt-icon class="text-zt-xl" name="sliders" />
        <div class="inline-flex outline-unset">
          <span class="text-neutro">{{ $t("message.HeaderComponent.filters.filters") }}</span>
          <zt-icon :name="showFilterOptions ? 'caret-up' : 'caret-down'" class="caret" />
        </div>
      </div>
      <div v-if="downloadDocs">
        <DownloadDocuments />
      </div>
    </div>
    <div class="w-full bg-white mt-2 mb-3 px-3" v-if="showFilterOptions">
      <div class="mb-3">
        <h2 class="text-zt-xl">{{ $t("message.DocumentsComponents.filterBy") }}</h2>
      </div>
      <div
        class="relative"
        :style="{ height: '70px' }"
        v-if="loadingFolderOptions && folderListName.length === 0"
      >
        <loader />
      </div>
      <div v-else class="flex flex-wrap">
        <button
          data-vs-button="folder"
          class="outline-unset"
          v-for="(folder, index) in folderListName"
          :key="index"
          @click="addFolderSelected(folder)"
        >
          <zt-chip square outline :class="isFolderSelected(folder) ? 'selected' : 'locked'">
            {{ getFolderName(folder) }}
          </zt-chip>
        </button>
      </div>
      <div>
        <h3 class="py-2">
          {{ $t('message.documentComponent.filters.dates.searchByPeriod') }}
        </h3>
        <div class="flex justify-between">
          <div>
            <v-menu ref="menuStart" v-model="datePickerStart.menu" :close-on-content-click="false"
              :return-value.sync="datePickerStart.date" lazy transition="scale-transition" offset-y full-width
              max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field data-vs-input="start-date" style="margin-right: 1em;" v-model="setInputStartDate"
                  :label="languages.filters.dates.dateSince" append-icon="event" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="datePickerStart.date" @input="setInputStartPicker"
                @change="datepickerDateOrder(datePickerStart.date)" type="month" :locale="vuetifyLocale" no-title scrollable>
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="pr-2">
            <v-menu ref="menuEnd" v-model="datePickerEnd.menu" :close-on-content-click="false"
              :return-value.sync="datePickerEnd.date" lazy transition="scale-transition" offset-y full-width
              max-width="290px" min-width="290px" z-index="1000">
              <template v-slot:activator="{ on }">
                <v-text-field data-vs-input="last-date" style="margin-right: 1em;" :disabled="!datePickerStart.date"
                  v-model="setInputEndDate" :label="languages.filters.dates.dateLast" append-icon="event" readonly
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker @input="
                datePickerEnd.menu = false
              $refs.menuEnd.save(datePickerEnd.date)
                " @change="datepickerDateOrder(datePickerEnd.date)" v-model="datePickerEnd.date" type="month"
                :locale="vuetifyLocale" :min="minDateTo" no-title scrollable>
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <div class="w-full flex flex-col">
        <zt-button data-vs-button="clean-filters" outlined color="primary" @click="cleanFilters()" class="mb-2">
          <zt-icon name="trash-outline text-zt-xl" />
          <span class="pl-2 font-bold">{{
            $t('message.documentComponent.filters.CleanFilters')
            }}</span>
        </zt-button>
        <zt-button data-vs-button="save-filters" class="font-bold" @click="applyFilters()">{{
          $t('message.documentComponent.filters.saveFilters') }}</zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { filter, includes, isEmpty, isObject } from 'lodash'
import moment from 'moment'
import DownloadDocuments from './DownloadDocuments'
import Loader from '@/components/commons/loader'
const formatInput = (date, format) => {
  return moment(date).format(format)
}
export default {
  name: 'FilterBar',
  props: ['setFilters', 'downloadDocs', 'appliedFilters'],
  components: {
    DownloadDocuments,
    Loader
  },
  data() {
    return {
      loadingFolderOptions: false,
      showFilterOptions: false,
      datePickerStart: {
        date: '',
        dateInverterStart: '',
        menu: false,
        modal: false,
        dateDecodeStart: ''
      },
      datePickerEnd: {
        date: '',
        dateInverterEnd: '',
        menu: false,
        modal: false,
        dateDecodeEnd: ''
      },
      foldersSelected: [],
      languages: {
        filters: {
          dates: {
            dateSince: this.$t(
              'message.documentComponent.filters.dates.dateSince'
            ),
            dateLast: this.$t(
              'message.documentComponent.filters.dates.dateLast'
            )
          }
        }
      }
    }
  },
  computed: {
    ...mapState('documents', ['documents']),
    ...mapGetters({
      locale: 'getLocale'
    }),
    ...mapGetters('documents', ['foldersName']),
    minDateTo() {
      return this.datePickerStart.date
    },
    setInputStartDate() {
      if (!this.datePickerStart.date) {
        return null
      }
      return formatInput(this.datePickerStart.date, 'MM/YYYY')
    },
    setInputEndDate() {
      if (!this.datePickerEnd.date) {
        return null
      }
      return formatInput(this.datePickerEnd.date, 'MM/YYYY')
    },
    isFolderSelected() {
      return folder => {
        if (isObject(folder)) {
          const folderId = folder.carpeta_id
          return this.foldersSelected.some(
            folderSelected => folderSelected === folderId
          )
        }
        return includes(this.foldersSelected, folder)
      }
    },
    vuetifyLocale() {
      return this.locale === 'br' ? 'pt' : 'es'
    },
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
    folderListName() {
      if (this.isInboxDocumentActivated) {
        return this.$store.state.documents.folders
      }
      return this.foldersName
    }
  },
  watch: {
    showFilterOptions() {
      this.getFoldersOptions()
    },
    appliedFilters: {
      handler() {
        this.getAppliedFilters()
      },
      deep: true
    }
  },
  created() {
    this.getAppliedFilters()
  },
  methods: {
    ...mapActions('documents', ['setFolderAvailable']),
    async getFoldersOptions() {
      if (this.showFilterOptions && this.isInboxDocumentActivated) {
        if (!this.$store.state.documents.folders.length)
          this.loadingFolderOptions = true
        await this.setFolderAvailable()
        this.loadingFolderOptions = false
      }
    },
    getAppliedFilters() {
      if (this.isInboxDocumentActivated && isEmpty(this.appliedFilters)) {
        return
      }
      if (this.appliedFilters.foldersSelected) {
        this.foldersSelected = this.appliedFilters.foldersSelected
      }
      if (this.appliedFilters.dateFilters) {
        const { start, end } = this.appliedFilters.dateFilters
        if (start) {
          this.datePickerStart.date = start
            .split('/')
            .reverse()
            .join('-')
        }
        if (end) {
          this.datePickerEnd.date = end
            .split('/')
            .reverse()
            .join('-')
        }
      }
    },
    getFolderName(folder) {
      if (isObject(folder)) {
        return folder.carpeta_nombre
      }
      return folder
    },
    setInputStartPicker() {
      this.$refs.menuStart.save(this.datePickerStart.date)
      this.$refs.menuEnd.save(this.datePickerEnd.date)
      this.datePickerStart.menu = false
    },
    addFolderSelected(folder) {
      if (isObject(folder)) {
        const folderId = folder.carpeta_id
        if (
          this.foldersSelected.some(
            folderSelected => folderSelected === folderId
          )
        ) {
          this.foldersSelected = this.foldersSelected.filter(
            folderSelected => folderSelected !== folderId
          )
        } else {
          this.foldersSelected.push(folderId)
        }
        return
      }
      if (includes(this.foldersSelected, folder)) {
        const temp = filter(
          this.foldersSelected,
          folderSelected => folderSelected !== folder
        )
        return (this.foldersSelected = temp)
      }
      this.foldersSelected.push(folder)
    },
    datepickerDateOrder(value) {
      if (this.datePickerStart.date === value) {
        let result = value
          .split('-')
          .reverse()
          .join('/')
        this.datePickerStart.dateInverterStart = result
        this.datePickerEnd.date = this.datePickerStart.date
        this.datePickerEnd.dateInverterEnd = result
      }
      if (this.datePickerEnd.date === value) {
        this.datePickerEnd.dateInverterEnd = value
          .split('-')
          .reverse()
          .join('/')
      }
    },
    applyFilters() {
      if (
        isEmpty(this.foldersSelected) &&
        isEmpty(this.datePickerStart.date) &&
        isEmpty(this.datePickerEnd.date)
      ) {
        return
      }
      this.setFilters({
        foldersSelected: this.foldersSelected,
        dateFilters: {
          start: this.setInputStartDate,
          end: this.setInputEndDate
        }
      })
    },
    cleanFilters() {
      this.foldersSelected = []
      this.datePickerStart.date = ''
      this.datePickerEnd.date = ''
      this.datePickerStart.dateInverterStart = ''
      this.datePickerEnd.dateInverterEnd = ''
      this.setFilters({})
    }
  }
}
</script>

<style lang="css" scoped>
.outline-unset {
  outline: unset;
}

::v-deep .bg-zt-primary-200.document--menu {
  background-color: var(--branding-primary, --v-primary-base);
}

::v-deep .bg-zt-primary-200 {
  background-color: var(--branding-primary, --v-primary-base);
}

.filters--container {
  min-height: 64px;
}

.filter--action {
  display: flex;
  padding: 10px 16px;
  gap: 8px;

  width: 120px;
  height: 36px;

  border-radius: 4px;
  font-size: 14px;

  border-color: var(--branding-primary, --v-primary-base);
  color: var(--branding-primary, --v-primary-base);
}

.filter--action-open {
  color: #707070;
  border-color: #707070;
  background: #dedede;
}

.zt-icon.caret {
  margin-left: 10px;
}

.zt-chip {
  padding: 6px !important;
  display: flex;
  justify-content: center;
  font-size: 1rem !important;
  text-transform: uppercase;
  margin: 0 8px 9px 0 !important;
  cursor: pointer !important;
}

.zt-chip.locked {
  background-color: #ebebeb !important;
  color: #575757 !important;
  border-color: #575757 !important;
}

.zt-chip.selected {
  color: #fff;
  background: var(--branding-primary, --v-primary-base) !important;
}
</style>
